<template>
    <footer>

    </footer>
</template>

<script>

    export default {
        name: "footer-div",
        data() {
            return {

            }
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import "./footer.scss";
</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue